import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const IMAGEOFSLIDESHOWBLOCK_LEGACY_FIELD_ORDER = [
  "desktop_image_size",
  "mobile_image_size",
  "image"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  imageOfSlideShowBlockDescriptor: _generatedImageOfSlideShowBlockDescriptor,
  imageOfSlideShowBlockBlocDefinition,
  imageOfSlideShowBlockDashboardLayout,
  imageOfSlideShowBlockConfig,
  imageOfSlideShowBlockResolveConfig,
  imageOfSlideShowBlockProperties,
} = doodBlockConfig(
  {
    name: "Image of slideshow",
    componentType: 'ImageOfSlideShowBlockComponent',
    category: 'content',
    description: "Image of slideshow.",
    keywords: [],
    allowedIn: [
      { bloc: "SlideShowImageBlockComponent", slot: "images" },
    ],
    sharedFields: {}
  },

  () => ({
    desktop_image_size: propertyValue({
      type: 'select',
      value: "2",
      options: {
        label: "pages.blocks.image-of-slide-show.desktop-image-size.label",
        multiple: false,
        choices: [
          {
            value: "1",
            label: "pages.blocks.image-of-slide-show.desktop-image-size.options.25",
          },
          {
            value: "2",
            label: "pages.blocks.image-of-slide-show.desktop-image-size.options.50",
          },
          {
            value: "3",
            label: "pages.blocks.image-of-slide-show.desktop-image-size.options.75",
          },
          {
            value: "full",
            label: "pages.blocks.image-of-slide-show.desktop-image-size.options.100",
          }
        ]
      }
    }),
    mobile_image_size: propertyValue({
      type: 'select',
      value: "full",
      options: {
        label: "pages.blocks.image-of-slide-show.mobile-image-size.label",
        multiple: false,
        choices: [
          {
            value: "1",
            label: "pages.blocks.image-of-slide-show.mobile-image-size.options.25",
          },
          {
            value: "2",
            label: "pages.blocks.image-of-slide-show.mobile-image-size.options.50",
          },
          {
            value: "3",
            label: "pages.blocks.image-of-slide-show.mobile-image-size.options.75",
          },
          {
            value: "full",
            label: "pages.blocks.image-of-slide-show.mobile-image-size.options.100",
          }
        ]
      }
    }),
    image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.image-of-slide-show.image.label",
        help: "pages.blocks.image-of-slide-show.image.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.image-of-slide-show.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.image-of-slide-show.fieldset.image.label",
            fields: ["image"],
          },
          {
            legend: "pages.blocks.image-of-slide-show.fieldset.size.label",
            fields: ["desktop_image_size", "mobile_image_size"],
          },
        ],
      },
    ],
  })
);

export function imageOfSlideShowBlockDescriptor(): IBlockDescriptor;
export function imageOfSlideShowBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function imageOfSlideShowBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedImageOfSlideShowBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedImageOfSlideShowBlockDescriptor, imageOfSlideShowBlockProperties, fieldOrder);
}

export {
  imageOfSlideShowBlockBlocDefinition,
  imageOfSlideShowBlockDashboardLayout,
  imageOfSlideShowBlockProperties,
  imageOfSlideShowBlockConfig,
  imageOfSlideShowBlockResolveConfig,
};

export type ImageOfSlideShowBlockConfig = typeof imageOfSlideShowBlockConfig;
